import Vue from "vue"
import Vuex from "vuex"
import VueAxios from "vue-axios"
import { securedAxiosInstance, plainAxiosInstance } from "../backend/axios"

import { CenterActions, CenterGetters, CenterMutations, CenterState } from "./modules/center.store"
import { SubscriptionActions, SubscriptionGetters, SubscriptionMutations, SubscriptionState } from "./modules/subscription.store"

import { ParentFormActions, ParentFormGetters, ParentFormMutations, ParentFormState } from "./modules/parent-form.store"
import { CreditActions, CreditGetters, CreditMutations, CreditState } from "./modules/credit.store"
import { AvailabilitiesActions, AvailabilitiesGetters, AvailabilitiesMutations, AvailabilitiesState } from "./modules/availabilities.store"
import { AnalyticsActions, AnalyticsGetters, AnalyticsMutations, AnalyticsState } from "./modules/analytics.store"

import { TagsActions, TagsGetters, TagsMutations, TagsState } from "./modules/tags.store"

import { SalesPipelineActions, SalesPipelineGetters, SalesPipelineMutations, SalesPipelineState } from "./modules/sales-pipeline.store"
import { CalendarActions, CalendarGetters, CalendarMutations, CalendarState } from "./modules/calendar.store"

import { ClientActions, ClientGetters, ClientMutations, ClientState } from "./modules/client.store"
import { TaskActions, TaskGetters, TaskMutations, TaskState } from "./modules/task.store"
import { SessionActions, SessionGetters, SessionMutations, SessionState } from "./modules/session.store"
import { ReportActions, ReportGetters, ReportMutations, ReportState } from "./modules/report.store"
import { UserActions, UserGetters, UserMutations, UserState } from "./modules/user.store"
import { DatabankActions, DatabankGetters, DatabankMutations, DatabankState } from "./modules/databank.store"
import { TaskCodesActions, TaskCodesGetters, TaskCodesMutations, TaskCodesState } from "./modules/tasks-codes"
import { problemBehaviorActions, problemBehaviorGetters, problemBehaviorMutations, ProblemBehaviorState } from "./modules/problem-behavior"

Vue.use(Vuex)
Vue.use(VueAxios, {
  secured: securedAxiosInstance,
  plain: plainAxiosInstance
})

/*
  NOTE: Update this note after splitting and refactoring the store
  List of split and refactored items
  - center
  - subscription
  //
  - parent form
  - credit
  - availabilities
  - analytics
  - user
  //
  - tags
  //
  - sales pipeline
  - calendar
  //
  - client
  - task
  - session
  - report
*/

export const store = new Vuex.Store({
  state: {
    viewMode: "",
    //
    ...CenterState,
    ...SubscriptionState,
    //
    ...ParentFormState,
    ...CreditState,
    ...AvailabilitiesState,
    ...AnalyticsState,
    ...UserState,
    //
    ...TagsState,
    //
    ...SalesPipelineState,
    ...CalendarState,
    // client property
    ...ClientState,
    ...TaskState,
    ...SessionState,
    ...ReportState,
    //
    ...DatabankState,
    //
    ...TaskCodesState,
    //
    //
    ...ProblemBehaviorState,
    //
    databankTargets: [],
    totalDatabankTargets: [],
    //
    // repository
    centerTargets: [],
    totalCenterTargets: 0,
    curriculum: null,
    curriculums: [],
    totalCurriculums: 0,
    centerPrompts: [],
    // client property
    cumulativeGraph: {
      labels: [],
      datasets: []
    },
    cumulativeTable: [],
    //
    actionRecommendations: [],
    totalActionRecommendations: 0,
    //
    target: null,
    targets: [],
    totalTargets: 0,
    entry: null,
    entries: [],
    graphEntries: {
      labels: [],
      datasets: [],
      recorded_by: []
    }
  },
  getters: {
    viewMode: (state) => {
      return state.viewMode
    },
    //
    ...CenterGetters,
    ...SubscriptionGetters,
    //
    ...ParentFormGetters,
    ...CreditGetters,
    ...AvailabilitiesGetters,
    ...AnalyticsGetters,
    ...UserGetters,
    //
    ...TagsGetters,
    //
    ...SalesPipelineGetters,
    ...CalendarGetters,
    //
    ...ClientGetters,
    ...TaskGetters,
    ...SessionGetters,
    ...ReportGetters,
    //

    //
    ...DatabankGetters,
    //

    //
    ...TaskCodesGetters,
    //

    //
    ...problemBehaviorGetters,
    //

    centerTargets: (state) => {
      return state.centerTargets
    },

    databankTargets: (state) => {
      return state.databankTargets
    },

    totalDatabankTargets: (state) => {
      return state.totalDatabankTargets
    },

    totalCenterTargets: (state) => {
      return state.totalCenterTargets
    },
    //
    curriculum: (state) => {
      return state.curriculum
    },
    curriculums: (state) => {
      return state.curriculums
    },
    totalCurriculums: (state) => {
      return state.totalCurriculums
    },
    //
    centerPrompts: (state) => {
      return state.centerPrompts
    },
    //
    cumulativeGraph: (state) => {
      return state.cumulativeGraph
    },
    cumulativeTable: (state) => {
      return state.cumulativeTable
    },
    //
    actionRecommendations: (state) => {
      return state.actionRecommendations
    },
    totalActionRecommendations: (state) => {
      return state.totalActionRecommendations
    },
    //
    target: (state) => {
      return state.target
    },
    targets: (state) => {
      return state.targets
    },
    totalTargets: (state) => {
      return state.totalTargets
    },
    entry: (state) => {
      return state.entry
    },
    entries: (state) => {
      return state.entries
    },
    graphEntries: (state) => {
      return state.graphEntries
    }
  },
  mutations: {
    setViewMode: (state, data) => {
      Vue.set(state, "viewMode", data)
    },
    //
    ...CenterMutations,
    ...SubscriptionMutations,
    //
    ...ParentFormMutations,
    ...CreditMutations,
    ...AvailabilitiesMutations,
    ...AnalyticsMutations,
    ...UserMutations,
    //
    ...TagsMutations,
    //
    ...SalesPipelineMutations,
    ...CalendarMutations,
    //
    ...ClientMutations,
    ...TaskMutations,
    ...SessionMutations,
    ...ReportMutations,
    //

    //
    ...DatabankMutations,
    //

    //
    ...TaskCodesMutations,
    //

    //
    ...problemBehaviorMutations,
    //
    setCenterTarget: (state, data) => {
      if (data) {
        const index = state.centerTargets.findIndex((i) => Number(i.id) === Number(data.id))
        if (index > -1) {
          const arr = [...state.centerTargets]
          arr[index] = data
          Vue.set(state, "centerTargets", arr)
        }
      }
    },
    setCenterTargets: (state, data) => {
      Vue.set(state, "centerTargets", data.targets)
      Vue.set(state, "totalCenterTargets", data.total_count)
    },

    setDatabankTarget: (state, data) => {
      if (data) {
        const index = state.databankTargets.findIndex((i) => Number(i.id) === Number(data.id))
        if (index > -1) {
          const arr = [...state.databankTargets]
          arr[index] = data
          Vue.set(state, "databankTargets", arr)
        }
      }
    },
    addCenterTarget: (state, data) => {
      Vue.set(state, "centerTargets", [data, ...state.centerTargets])
      Vue.set(state, "totalCenterTargets", state.totalCenterTargets + 1)
    },

    addDatabankTarget: (state, data) => {
      Vue.set(state, "databankTargets", [data, ...state.databankTargets])
      Vue.set(state, "totalDatabankTargets", state.totalDatabankTargets + 1)
    },
    removeCenterTarget: (state, data) => {
      Vue.set(state, "centerTargets", state.centerTargets.filter((i) => Number(i.id) !== Number(data.id)))
      Vue.set(state, "totalCenterTargets", state.totalCenterTargets - 1)
    },

    removeDatabankTarget: (state, data) => {
      Vue.set(state, "databankTargets", state.databankTargets.filter((i) => Number(i.id) !== Number(data.id)))
      Vue.set(state, "totalDatabankTargets", state.totalDatabankTargets - 1)
    },

    //
    setDatabankTargets: (state, data) => {
      Vue.set(state, "databankTargets", data.targets)
      Vue.set(state, "totalDatabankTargets", data.total_count)
    },
    //
    setCurriculum: (state, data) => {
      if (data) {
        const index = state.curriculums.findIndex((i) => Number(i.id) === Number(data.id))
        if (index > -1) {
          const arr = [...state.curriculums]
          arr[index] = data
          Vue.set(state, "curriculums", arr)
        }
        Vue.set(state, "curriculum", data)
      }
    },
    setCurriculums: (state, data) => {
      Vue.set(state, "curriculums", data.curriculums)
      Vue.set(state, "totalCurriculums", data.total_count)
    },
    addCurriculum: (state, data) => {
      Vue.set(state, "curriculums", [data, ...state.curriculums])
      Vue.set(state, "totalCurriculums", state.totalCurriculums + 1)
    },
    removeCurriculum: (state, data) => {
      Vue.set(state, "curriculums", state.curriculums.filter((i) => Number(i.id) !== Number(data.id)))
      Vue.set(state, "totalCurriculums", state.totalCurriculums - 1)
    },
    //
    setCenterPrompt: (state, data) => {
      if (data) {
        const index = state.centerPrompts.findIndex((i) => Number(i.id) === Number(data.id));
        if (index > -1) {
          const arr = [...state.centerPrompts];
          arr[index] = data;

          if (data.type === "Prompt::Sbt") {
            const sbtPrompts = arr.filter(prompt => prompt.type === "Prompt::Sbt");
            const sortedSbtPrompts = sbtPrompts.sort((a, b) => b.score - a.score)
            Vue.set(state, "centerPrompts", sortedSbtPrompts);
          } else if (data.type === "Prompt::Prompting") {
            const promptingPrompts = arr.filter(prompt => prompt.type === "Prompt::Prompting");
            Vue.set(state, "centerPrompts", promptingPrompts);
          }
        }
      }
    },
    setCenterPrompts: (state, data) => {
      Vue.set(state, "centerPrompts", data)
    },
    removeCenterPrompt: (state, data) => {
      Vue.set(state, "centerPrompts", state.centerPrompts.filter((i) => Number(i.id) !== Number(data.id)))
    },
    //
    setCumulativeGraph: (state, data) => {
      const result = {
        labels: data.labels ? data.labels : [],
        datasets: data.datasets ? data.datasets : []
      }
      Vue.set(state, "cumulativeGraph", result)
    },
    setCumulativeTable: (state, data) => {
      const result = []
      Object.keys(data).forEach((key) => {
        const mastered = data[key].filter((i) => i.status === "mastered")
        result.push({
          key,
          number_of_target: data[key].length,
          number_of_mastered: mastered.length,
          targets: data[key]
        })
      })
      Vue.set(state, "cumulativeTable", result)
    },
    //
    setActionRecommendations: (state, data) => {
      Vue.set(state, "actionRecommendations", data.action_recommendations)
      Vue.set(state, "totalActionRecommendations", data.total_count)
    },
    //
    setTarget: (state, data) => {
      if (data) {
        const index = state.targets.findIndex((i) => Number(i.id) === Number(data.id))
        if (index > -1) {
          const arr = [...state.targets]
          arr[index] = data
          Vue.set(state, "targets", arr)
        }
      }
      Vue.set(state, "target", data)
    },
    setTargets: (state, data) => {
      Vue.set(state, "targets", data.targets)
      Vue.set(state, "totalTargets", data.total_count)
    },
    addTarget: (state, data) => {
      Vue.set(state, "targets", [data, ...state.targets])
      Vue.set(state, "totalTargets", state.totalTargets + 1)
    },
    removeTarget: (state, data) => {
      Vue.set(state, "targets", state.targets.filter((i) => Number(i.id) !== Number(data.id)))
      Vue.set(state, "totalTargets", state.totalTargets - 1)
    },
    //
    setEntry: (state, data) => {
      if (data) {
        const index = state.entries.findIndex(item => item.id === data.id)
        if (index > -1) {
          const arr = [...state.entries]
          arr[index] = data
          Vue.set(state, "entries", arr)
        }
      }
      Vue.set(state, "entry", data)
    },
    setEntries: (state, data) => {
      Vue.set(state, "entries", data)
    },
    setGraphEntries: (state, data) => {
      const { labels = [], datasets = [], recorded_by: r = [] } = data
      Vue.set(state, "graphEntries", { labels, datasets, recorded_by: r })
    }
  },
  actions: {
    showToast: ({ context }, { title = "", message = "", type }) => {
      function concatObjectKeyValue(obj) {
        let result = [];
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            const temp = obj[key];
            if (typeof temp === "object") {
              result.push(concatObjectKeyValue(obj[key]));
            } else {
              const k = Number(key);
              if (!isNaN(k)) result.push(obj[key])
              else result.push(`${key} ${obj[key]}`);
            }
          }
        }
        return result;
      }
      const temp = {
        title: typeof title === "object" ? concatObjectKeyValue(title).join(", ") : title,
        message: typeof message === "object" ? concatObjectKeyValue(message).join(", ") : message
      }
      let currentTitle = temp.title || temp.message;
      let currentMessage = temp.title ? temp.message : "";
      const toastMessage = `
<div class='font-body' style='${currentTitle ? `margin-top: 6px;` : ``}'>
  ${currentTitle ? `<div class='font-semibold capitalize-first' style='font-size: 16px; margin-bottom: 8px;'>${currentTitle}</div>` : ``}
  ${currentMessage ? `<div style='font-size: 14px; line-height: 22px;'>${currentMessage}</div>` : ``}
</div>
      `;
      Vue.toasted.show(toastMessage, { type })
    },
    setViewMode: ({ commit }, data) => {
      commit("setViewMode", data)
    },
    //
    actionGet: ({ context }, { url }) => {
      return Vue.axios.secured.get(url)
        .then((response) => {
          return { success: true, data: response.data }
        })
        .catch(error => {
          console.error(error)
          return { success: false, data: null }
        })
    },
    actionPost: ({ context }, { url, params }) => {
      return Vue.axios.secured.post(url, params)
        .then((response) => {
          return { success: true, data: response.data }
        })
        .catch(error => {
          console.error(error)
          return { success: false, data: error.response && error.response.data }
        })
    },
    actionPatch: ({ context }, { url, params }) => {
      return Vue.axios.secured.patch(url, params)
        .then((response) => {
          return { success: true, data: response.data }
        })
        .catch(error => {
          console.error(error)
          return { success: false, data: error.response && error.response.data }
        })
    },
    actionDelete: ({ context }, { url, params }) => {
      return Vue.axios.secured.delete(url, params)
        .then((response) => {
          return { success: true, data: response.data }
        })
        .catch(error => {
          console.error(error)
          return { success: false, data: error.response && error.response.data }
        })
    },
    actionDownload: ({ dispatch }, data) => {
      return Vue.axios.secured.get(data.url, { responseType: "blob" })
        .then(response => {
          const title = data.title || "Download content";
          const message = data.message || "Please wait, downloading content.";
          dispatch("showToast", { title, message, type: "success" })

          const href = URL.createObjectURL(response.data);
          const link = document.createElement("a");

          let filename = "";
          const disposition = response.headers["content-disposition"];
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }

          link.href = href;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          return { success: true }
        })
        .catch(error => {
          console.error(error)
          return { success: false }
        })
    },
    //
    ...CenterActions,
    ...SubscriptionActions,
    //
    ...ParentFormActions,
    ...CreditActions,
    ...AvailabilitiesActions,
    ...AnalyticsActions,
    ...UserActions,
    //
    ...TagsActions,
    //
    ...SalesPipelineActions,
    ...CalendarActions,
    //
    ...ClientActions,
    ...TaskActions,
    ...SessionActions,
    ...ReportActions,
    //

    //
    ...DatabankActions,
    //

    //
    ...TaskCodesActions,
    //

    //
    ...problemBehaviorActions,
    //
    getCurriculums: ({ commit, dispatch }, data = {}) => {
      const params = data.params || ""
      return Vue.axios.secured.get(`/api/v1/curriculums${params}`)
        .then(response => {
          commit("setCurriculums", response.data)
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to fetch curricula from server."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    getCurriculum: ({ commit, dispatch }, data) => {
      return Vue.axios.secured.get(`/api/v1/curriculums/${data.id}`)
        .then(response => {
          commit("setCurriculum", response.data)
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to fetch curriculum from server."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    createCurriculum: ({ commit, dispatch }, data) => {
      return Vue.axios.secured.post("/api/v1/curriculums", { curriculum: data, curriculumable_id: data.curriculumable_id, curriculumable_type: data.curriculumable_type })
        .then(response => {
          commit("addCurriculum", response.data)
          const title = `New curriculum created`
          const message = `Success! The curriculum <b>${response.data.name}</b> has been created.`
          dispatch("showToast", { title, message, type: "success" })
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to create curriculum."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    updateCurriculum: ({ commit, dispatch }, data) => {
      return Vue.axios.secured.patch(`/api/v1/curriculums/${data.id}`, { curriculum: data })
        .then(response => {
          commit("setCurriculum", response.data)
          const title = `Curriculum updated`
          const message = `Success! The curriculum has been updated.`
          dispatch("showToast", { title, message, type: "success" })
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to update curriculum."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    deleteCurriculum: ({ commit, dispatch }, data) => {
      return Vue.axios.secured.delete(`/api/v1/curriculums/${data.id}`)
        .then(response => {
          commit("removeCurriculum", data)
          const title = `Curriculum deleted`
          const message = `Success! The curriculum <b>${data.name}</b> has been deleted.`
          dispatch("showToast", { title, message, type: "success" })
          return { success: true }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to delete curriculum."
          dispatch("showToast", { message, type: "error" })
          return { success: false }
        })
    },
    //
    getCenterPrompts: ({ commit, dispatch }, data) => {
      const params = data.params || ""
      return Vue.axios.secured.get(`/api/v1/center_prompts${params}`)
        .then(response => {
          commit("setCenterPrompts", response.data);
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to fetch prompts from server.";
          dispatch("showToast", { message, type: "error" });
          return { success: false, data: null }
        });
    },
    createCenterPrompt: ({ state, dispatch }, data) => {
      /*
        prompt: {
          name: String;
          abbreviation: String; // length = 1-3
          shape: 'square' | 'circle' | 'triangle' | 'diamond';
          color: 'cherry' | 'blush' | 'gold' | 'daffodil' | 'lake' | 'mint' | 'sky' | 'hydrangeas' | 'grey' | 'primary';
          position: Number;
        }
      */
      return Vue.axios.secured.post("/api/v1/center_prompts", { prompt: data.prompt })
        .then(response => {
          state.centerPrompts.push(response.data)
          const message = `Prompt has been successfully added.`
          dispatch("showToast", { message, type: "success" })
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to create prompt."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    updateCenterPrompt: ({ commit, dispatch }, data) => {
      return Vue.axios.secured.patch(`/api/v1/center_prompts/${data.id}`, { prompt: data.prompt })
        .then(response => {
          commit("setCenterPrompt", response.data);
          const message = `Prompt ${data.prompt.name} has been successfully updated.`;
          dispatch("showToast", { message, type: "success" });
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to update prompt.";
          dispatch("showToast", { message, type: "error" });
          return { success: false, data: null }
        });
    },
    moveCenterPrompt: ({ dispatch }, data) => {
      return Vue.axios.secured.patch(`/api/v1/center_prompts/${data.id}`, { prompt: data.prompt })
        .then(response => {
          const message = `Prompt ${data.prompt.name} has been successfully updated.`
          dispatch("showToast", { message, type: "success" })
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to update prompt."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    deleteCenterPrompt: ({ commit, dispatch }, data) => {
      return Vue.axios.secured.delete(`/api/v1/center_prompts/${data.id}`)
        .then(response => {
          commit("removeCenterPrompt", data)
          const message = `Prompt ${data.prompt.name} has been successfully removed.`
          dispatch("showToast", { message, type: "success" })
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to delete prompt."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    //
    getCumulative: ({ commit, dispatch }, data = {}) => {
      const params = data.params || ""
      const isGraphView = params.includes("view=graph")
      const isTableView = params.includes("view=table")
      return Vue.axios.secured.get(`/api/v1/clients/${data.client_id}/cumulative${params}`)
        .then(response => {
          if (isGraphView) commit("setCumulativeGraph", response.data)
          if (isTableView) commit("setCumulativeTable", response.data)
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to fetch cumulative graph data from server."
          dispatch("showToast", { message, type: "error" })
        })
    },
    //
    getActionRecommendations: ({ commit, dispatch }, data = {}) => {
      const params = data.params || ""
      return Vue.axios.secured.get(`/api/v1/clients/${data.id}/action_recommendations${params}`)
        .then(response => {
          commit("setActionRecommendations", response.data)
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to fetch action recommendations from server."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    createActionRecommendation: ({ dispatch }, data) => {
      return Vue.axios.secured.post(`/api/v1/action_recommendations`, { action_recommendation: data.action_recommendation })
        .then(response => {
          dispatch("getTarget", { kind: data.kind, id: data.target_id })
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to create action recommendation."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    updateActionRecommendation: ({ dispatch }, data) => {
      return Vue.axios.secured.patch(`/api/v1/action_recommendations/${data.id}`, { action_recommendation: data.action_recommendation })
        .then(response => {
          dispatch("getTarget", { kind: data.kind, id: data.target_id })
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to update action recommendation."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    acceptActionRecommendation: ({ dispatch }, data) => {
      // ids separated by comma
      return Vue.axios.secured.patch(`/api/v1/action_recommendations/accept`, { ids: data.ids })
        .then(response => {
          if (data.target_id) {
            dispatch("getTarget", { id: data.target_id })
          }
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to accept action recommendation."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    ignoreActionRecommendation: ({ dispatch }, data) => {
      // ids separated by comma
      return Vue.axios.secured.patch(`/api/v1/action_recommendations/ignore`, { ids: data.ids })
        .then(response => {
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to ignore action recommendation."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    //
    getTargets: ({ commit, dispatch }, data = {}) => {
      const params = data.params || ""
      const kind = data.kind || "client"
      return Vue.axios.secured.get(`/api/v1/targets${params}`)
        .then(response => {
          if (kind === "client") commit("setTargets", response.data)
          if (kind === "center") commit("setCenterTargets", response.data)
          if (kind === "databank") commit("setDatabankTargets", response.data)
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to fetch targets from server."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    getTarget: ({ commit, dispatch }, data) => {
      const kind = data.kind || "client"
      return Vue.axios.secured.get(`/api/v1/targets/${data.id}`)
        .then(response => {
          if (kind === "client") {
            commit("setEntries", response.data.entries)
            commit("setTarget", response.data)
          } else if (kind === "databank") {
            commit("setDatabankTarget", response.data)
          }
          if (kind === "center") {
            commit("setCenterTarget", response.data)
          }
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to fetch target from server."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    createTarget: ({ commit, dispatch }, data) => {
      const params = {
        kind: data.kind,
        target: data.target
      }
      if (data.client_id) {
        params.client_id = data.client_id
      }
      return Vue.axios.secured.post(`/api/v1/targets`, params)
        .then(response => {
          const target = { ...response.data, is_new: true }
          if (data.kind === "client") commit("addTarget", target)
          else if (data.kind === "databank") commit("addDatabankTarget", target)
          else if (data.kind === "center") commit("addCenterTarget", target)
          return { success: true, data: target }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to create target."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    updateTarget: ({ commit, dispatch }, data) => {
      const kind = data.kind || "client"
      return Vue.axios.secured.patch(`/api/v1/targets/${data.id}`, { target: data.target })
        .then(response => {
          if (kind === "client") {
            commit("setEntries", response.data.entries)
            commit("setTarget", response.data)
          }
          if (kind === "databank") {
            commit("setDatabankTarget", response.data)
          }
          if (kind === "center") {
            commit("setCenterTarget", response.data)
          }
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to update target."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    deleteTarget: ({ state, commit, dispatch }, data) => {
      const kind = data.kind || "client"
      return Vue.axios.secured.delete(`/api/v1/targets/${data.id}`)
        .then(response => {
          const title = "Target deleted"
          let message = ""
          if (kind === "client") {
            if (state.target.id === data.id) {
              commit("setTarget", null)
            }
            commit("removeTarget", data)
            message = `Success! The <b>${data.name}</b> target has been deleted.`
          }
          if (kind === "databank") {
            commit("removeDatabankTarget", data)
            message = `Success! The <b>${data.name}</b> target has been deleted from the databank.`
          }
          if (kind === "center") {
            commit("removeCenterTarget", data)
            message = `Success! The <b>${data.name}</b> target has been deleted from the databank.`
          }
          dispatch("showToast", { title, message, type: "success" })
          return { success: true }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to delete target."
          dispatch("showToast", { message, type: "error" })
          return { success: false }
        })
    },

    duplicateTarget: ({ commit, dispatch }, data) => {
      const kind = data.kind || "client"
      return Vue.axios.secured.post(`/api/v1/targets/${data.id}/duplicate`, { targetable_id: data.targetable_id, targetable_type: data.targetable_type })
        .then(response => {
          const target = { ...response.data, is_new: true }
          if (kind === "client") commit("addTarget", target)
          else if (kind === "databank") commit("addDatabankTarget", target)
          else commit("addCenterTarget", target)
          return { success: true, data: target }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to duplicate target."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    createBulkTarget: ({ dispatch }, data) => {
      // target_ids: ids separated by comma
      return Vue.axios.secured.post(`/api/v1/clients/${data.client_id}/bulk_create_targets`, { target_ids: data.target_ids })
        .then(response => {
          const title = "New target(s) added"
          const message = `Success! ${data.count} target(s) has been added from the databank. <br /> Please note that it may take some time to complete the process.`
          dispatch("showToast", { title, message, type: "success" })
          dispatch("checkTargetJob", { client_id: data.client_id, job_id: response.data.job_id })
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to create target."
          dispatch("showToast", { message, type: "error" })
          return { success: false, data: null }
        })
    },
    checkTargetJob: ({ state, commit, dispatch }, data) => {
      // check current client, if not same -> return
      const clientId = state.client ? state.client.id : null
      if (clientId !== data.client_id) return { success: false, data: null }
      //
      return Vue.axios.secured.get(`/api/v1/clients/${data.client_id}/check_duplicate_targets_job/${data.job_id}`)
        .then(response => {
          if (!response.data.job) {
            return { success: false, data: null };
          }
          commit("setClientTargetJob", response.data.job)
          const jobStatus = response.data.job.status
          if (jobStatus === "in_progress" || jobStatus === "pending") {
            setTimeout(() => {
              dispatch("checkTargetJob", data)
            }, 5000);
          }
          if (jobStatus === "completed") {
            const reloaded = {
              targets: response.data.targets,
              total_count: response.data.targets.length
            }
            commit("setTargets", reloaded)
          }
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to check target job from server."
          console.error(message)
          return { success: false, data: null }
        })
    },
    cancelTargetJob: ({ commit, dispatch }, data) => {
      return Vue.axios.secured.patch(`/api/v1/cancel_duplicate_targets_job/${data.job_id}`)
        .then(response => {
          commit("setClientTargetJob", response.data)
          const message = "Cancelled import";
          dispatch("showToast", { message, type: "success" })
          return { success: true, data: response.data }
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to cancel target job."
          console.error(message)
          return { success: false, data: null }
        })
    },
    //
    async getGraphEntries({ commit, dispatch }, data) {
      try {
        const params = data.params || ""
        const response = await Vue.axios.secured.get(`/api/v1/targets/${data.target_id}/graph${params}`)
        commit("setGraphEntries", response.data)
        return { success: true, data: response.data }
      } catch (error) {
        const message = (error.response && error.response.data) || "Unable to fetch graph data from server."
        dispatch("showToast", { message, type: "error" })
        commit("setGraphEntries", { labels: [], datasets: [], recorded_by: [] })
        return { success: false, data: null }
      }
    },
    updateEntry: ({ dispatch }, entry) => {
      return Vue.axios.secured.patch(`/api/v1/entries/${entry.id}`, { entry: entry })
        .then(response => {
          dispatch("getTarget", { id: response.data.target_id })
          const message = "Entry has been successfully updated."
          dispatch("showToast", { message, type: "success" })
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to update entry."
          dispatch("showToast", { message, type: "error" })
        })
    },
    deleteEntry: ({ dispatch }, entry) => {
      return Vue.axios.secured.delete(`/api/v1/entries/${entry.id}`)
        .then(response => {
          dispatch("getTarget", { id: entry.target_id })
          const message = "Entry has been successfully removed."
          dispatch("showToast", { message, type: "success" })
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to delete entry."
          dispatch("showToast", { message, type: "error" })
        })
    },
    //
    createPhaseLine: ({ dispatch }, { targetId, phaseLine }) => {
      return Vue.axios.secured.post(`/api/v1/targets/${targetId}/phase_lines`, { phase_line: phaseLine })
        .then(response => {
          dispatch("getTarget", { id: targetId })
          const message = "Phase line has been successfully added."
          dispatch("showToast", { message, type: "success" })
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to create phase line."
          dispatch("showToast", { message, type: "error" })
        })
    },
    updatePhaseLine: ({ dispatch }, data) => {
      return Vue.axios.secured.patch(`/api/v1/phase_lines/${data.id}`, { phase_line: data })
        .then(response => {
          dispatch("getTarget", { id: data.target_id })
          const message = "Phase line has been successfully updated."
          dispatch("showToast", { message, type: "success" })
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to update phase line."
          dispatch("showToast", { message, type: "error" })
        })
    },
    movePhaseLine: ({ dispatch }, data) => {
      return Vue.axios.secured.patch(`/api/v1/phase_lines/${data.id}/reposition`, { phase_line: data })
        .then(response => {
          dispatch("getTarget", { id: data.target_id })
          const message = "Phase line has been successfully updated."
          dispatch("showToast", { message, type: "success" })
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to update phase line."
          dispatch("showToast", { message, type: "error" })
        })
    },
    deletePhaseLine: ({ dispatch }, data) => {
      return Vue.axios.secured.delete(`/api/v1/phase_lines/${data.id}`)
        .then(response => {
          dispatch("getTarget", { id: data.target_id })
          const message = "Phase line has been successfully removed."
          dispatch("showToast", { message, type: "success" })
        })
        .catch(error => {
          const message = (error.response && error.response.data) || "Unable to delete phase line."
          dispatch("showToast", { message, type: "error" })
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js